import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {API_CODE_LENGTH} from '../../../services/constants';
import {Divider, Input} from 'antd';
import TranslatedText from '../../TranslatedText';

class VerificationCodeForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      resendActive: true,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onInputPaste = this.onInputPaste.bind(this);
    this.onResend = this.onResend.bind(this);
    this.recoveryCodeRefs = _.range(API_CODE_LENGTH).map(() => React.createRef());
  }

  onResend(event) {
    this.props.onResend(event);
    this.setState({resendActive: false});
    setTimeout(() => this.setState({resendActive: true}), 5000);
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.onSubmit(this.props.code);
  }

  onInputChange(event, index) {
    const newValue = this.props.code.substring(0, index) + event.target.value + this.props.code.substring(index + 1);
    this.props.onChange(newValue);
    if (index < API_CODE_LENGTH - 1 && /\d/.test(event.target.value)) {
      this.recoveryCodeRefs[index + 1].current.focus();
    }
    if (index > 0 && event.target.value === '') {
      this.recoveryCodeRefs[index - 1].current.focus();
    }
  }

  onInputPaste(event) {
    const pasteValue = event.clipboardData.getData('text').replace(/\s+/g, '');
    this.props.onChange(pasteValue);
  }

  getInputValue(index) {
    return /\d/.test(this.props.code[index])
      ? this.props.code[index]
      : '';
  }

  render() {
    return (
      <form onSubmit={this.onSubmit} className="verification-code-form" autoComplete="off">
        <div className="verification-code-form-info">
          <h3><TranslatedText transKey="modals.verification.codesent"/></h3>
          <p>
            <span><TranslatedText transKey="modals.verification.senttoemail"/></span>
            <span><TranslatedText transKey="modals.verification.typeitbelow"/></span>
          </p>
          {
            this.props.onResend && (
              this.state.resendActive
                ? <a className="verification-code-form-resend-code" onClick={this.onResend}><TranslatedText transKey="modals.verification.resentcode"/></a>
                : <span><TranslatedText transKey="modals.verification.codewasresent"/></span>
            )
          }
        </div>
        <Divider/>
        <div className="verification-code-form-enter">
          {this.props.isInvalid && <p className="error-msg"><TranslatedText transKey="modals.verification.codeinvalid"/></p>}
          <h3><TranslatedText transKey="modals.verification.entercode"/></h3>
          <div className="modal-form-group">
            {
              _.range(API_CODE_LENGTH).map(index => (
                <Input
                  key={`recovery-code-input-${index}`}
                  className="recovery-code-input"
                  maxLength={1}
                  ref={this.recoveryCodeRefs[index]}
                  value={this.getInputValue(index)}
                  onChange={event => this.onInputChange(event, index)}
                  onPaste={this.onInputPaste}
                  required
                />
              ))
            }
            {this.props.children}
          </div>
        </div>
      </form>
    );
  }
}

VerificationCodeForm.propTypes = {
  children: PropTypes.any,
  code: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onResend: PropTypes.func,
};

export default VerificationCodeForm;



// WEBPACK FOOTER //
// /src/components/modals/common/VerificationCodeForm.jsx